import React from 'react';
import { useParams } from 'react-router-dom';
import { BarChart3, Activity, Clock, LayoutGrid } from 'lucide-react';
import { MODULE_ICONS } from '../../../components/icons/ModuleIcons';
import { useSiteDisplayName } from '../../../utils/siteUtils';
import '../../../styles/np-theme.css';

// The module is not built yet. The page says so plainly instead of showing
// live-looking status tiles ("Provisioning…", "Evaluating…") with no data behind them.
const PLANNED = [
    { title: 'Forecasting', desc: 'Physical and ML day-ahead generation forecast', icon: BarChart3 },
    { title: 'Grid feed', desc: 'SLDC / RLDC schedule and real-time grid feedback', icon: Activity },
    { title: 'Scheduler', desc: 'Injection vs drawl scheduling and revisions', icon: Clock },
    { title: 'Automation', desc: 'Automated demand-response protocols', icon: LayoutGrid },
];

const DSMPage = () => {
    const { site } = useParams<{ site: string }>();
    const siteDisplayName = useSiteDisplayName(site);
    const DsmIcon = MODULE_ICONS.dsm;

    return (
        <div className="np-page min-h-screen">
            <div className="np-theme max-w-6xl mx-auto px-4 sm:px-6 pt-24 pb-12">
                <div className="flex flex-wrap items-center justify-between gap-3 pb-5 border-b border-slate-200">
                    <div className="np-pagehead">
                        <div className="np-pagehead__mark">
                            <DsmIcon size={20} />
                        </div>
                        <div style={{ minWidth: 0 }}>
                            <h1 className="np-pagehead__title">Demand Side Management</h1>
                            <div className="np-pagehead__meta">
                                <span className="np-pagehead__site">{siteDisplayName || site || 'SITE'}</span>
                                <span className="np-pagehead__desc">Forecasting and scheduling</span>
                            </div>
                        </div>
                    </div>
                    <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded border border-blue-200 bg-blue-50 text-xs text-blue-700 uppercase">
                        In development
                    </span>
                </div>

                <div className="np-note mt-6" role="status">
                    <p className="text-sm">
                        This module is being built and has no live data yet. Nothing on this page reflects your plant’s
                        current load or schedule.
                    </p>
                </div>

                <h2 className="mt-8 mb-3">What this module will cover</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                    {PLANNED.map(({ title, desc, icon: Icon }) => (
                        <div key={title} className="np-kpi">
                            <div className="np-kpi__head">
                                <span className="np-kpi__label">{title}</span>
                                <span className="np-kpi__mark"><Icon size={14} /></span>
                            </div>
                            <span className="np-kpi__hint" style={{ marginTop: 10 }}>{desc}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DSMPage;
